/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGitDeletedVb = (props: Props) => (
  <Icon viewBox="0 0 18 18" {...props}>
    <path d="M13.513 16c.79 0 1.488-.212 1.888-.636.4-.424.599-1.044.599-1.86 0-.826-.2-1.45-.603-1.871C14.996 11.21 14.3 11 13.513 11H11v5zm-1.48-1v-3H13.5c.45 0 .886.133 1.103.399s.324.55.324 1.104-.11.838-.328 1.102c-.218.263-.653.395-1.099.395z" />
  </Icon>
);
export { SvgGitDeletedVb as GitDeletedVb };
